import dayjs from 'dayjs'
import { i18n } from '@/lib/i18n'

/** Phần ghi chú dùng để hiển thị (khớp backend note-routes: `time` = thời điểm gốc ở nền tảng nguồn nếu có, không thì lúc tạo). */
export interface NoteLike {
  createdAt: string
  source?: string | null
  sourceLabel?: string | null
  sourceAt?: string | null
  time?: string | null
  createdBy?: { fullName: string | null } | null
}

/** Ghi chú do nhân viên viết trong eCDP (kể cả ghi chú hồ sơ cũ đã chuyển sang) — khác ghi chú đồng bộ / nhập file. */
export const isStaffNote = (n: Pick<NoteLike, 'source'>) => !n.source || n.source === 'manual' || n.source === 'legacy'

/** Thời điểm hiển thị / sắp xếp: thời điểm GỐC ở nguồn nếu có. */
export const noteTimeOf = (n: NoteLike): string => n.sourceAt || n.time || n.createdAt

export interface NoteMeta {
  /** Người viết hoặc tên nền tảng nguồn. */
  author: string
  /** Thời điểm hiển thị, đã định dạng. */
  when: string
  /** Chú thích nguồn — chỉ có với ghi chú đồng bộ / nhập file. */
  sourceNote: string | null
}

export function noteMeta(n: NoteLike): NoteMeta {
  const fmt = (iso: string) => dayjs(iso).format('HH:mm DD/MM/YYYY')
  const author = n.createdBy?.fullName || n.sourceLabel || (isStaffNote(n) ? i18n.t('sharedMisc:noteMeta.unknownAuthor') : i18n.t('sharedMisc:noteMeta.otherPlatform'))
  let sourceNote: string | null = null
  if (!isStaffNote(n)) {
    const from = n.source === 'import' ? i18n.t('sharedMisc:noteMeta.importedFromFile') : i18n.t('sharedMisc:noteMeta.syncedFrom', { source: n.sourceLabel || n.source })
    sourceNote = n.sourceAt
      ? i18n.t('sharedMisc:noteMeta.sourceTime', { from, date: fmt(n.sourceAt) })
      : i18n.t('sharedMisc:noteMeta.noSourceTime', { from })
  }
  return { author, when: fmt(noteTimeOf(n)), sourceNote }
}

/** Ghim trước, còn lại thời điểm hiển thị mới → cũ. */
export function sortNotes<T extends NoteLike & { isPinned: boolean }>(notes: T[]): T[] {
  return [...notes].sort((a, b) => Number(b.isPinned) - Number(a.isPinned) || noteTimeOf(b).localeCompare(noteTimeOf(a)))
}
